import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { actions as apiActions, selectors as apiSelectors } from 'zender-api-client';

import * as appSelectors from '../../selectors';
import Interaction from './Interaction.component';

const InteractionContainer = props => <Interaction {...props} />;

const mapStateToProps = state => ({
	pathName: appSelectors.router.pathNameSelector(state),
	queryParams: appSelectors.ui.queryParamsSelector(state),
	title: apiSelectors.stream.titleSelector(state),
	targetSettings: apiSelectors.target.targetSettingsSelector(state),
	target: apiSelectors.target.targetSelector(state),
});

const mapDispatchToProps = dispatch => ({
	setChannel: channelId => dispatch(apiActions.client.uiActions.config({ channelId })),
	clearAndGetChannel: bindActionCreators(
		apiActions.channel.uiActions.clearAndGetChannel,
		dispatch
	),
	clearAndGetStream: bindActionCreators(apiActions.stream.uiActions.clearAndGetStream, dispatch),
});

InteractionContainer.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(InteractionContainer)
);



// WEBPACK FOOTER //
// ./src/ui/interaction/Interaction.container.js